import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectAllCategories} from "../../slices/categoriesSlice";
import {rxShowBudgetCategoryEditor} from "../../slices/budgetCategoriesSlice";
import {FabButton} from "../../common/FabButton";
import {MODE_CREATE} from "../../codes";
import useProject from "../../util/useProject";

export const BudgetsFab = () => {
  const dispatch = useDispatch();

  const {runWithExpiration} = useProject();

  const transactionCategories = useSelector(selectAllCategories);

  const showCategoryEditor = (mode, category) => dispatch(rxShowBudgetCategoryEditor({mode, category}));

  if (transactionCategories.filter(a => a.active).length === 0) {
    return null;
  }

  return <FabButton onClick={runWithExpiration(() => {
    showCategoryEditor(MODE_CREATE, {});
  })}/>;
};
